import React, { useState, useEffect, Suspense } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../reducers'
import { DataGrid } from '@mui/x-data-grid'
import { useTheme } from '@mui/styles'
import { fetchLoadBalancerLog } from '../../actions'
import Icon from '@mui/material/Icon'
import { Clear as ClearIcon } from '@mui/icons-material'
import { Tooltip, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material'
import { useStyles } from './ReportingStyles'
import { caseDetailsColumns, loadBalancerColumns } from './tableColumnHeaders'

export function LoadBalancerLog({ user }): JSX.Element | null {
  const theme = useTheme()
  const classes = useStyles()
  const [statusOpen, setStatusOpen] = useState(false)
  const [status, setStatus] = useState([])
  const [runId, setRunId] = useState('')
  const gridPageSize = 10

  const loadBalancerRemarksRender = {
    field: 'remarks',
    headerName: 'Note',
    sortable: false,
    width: 220,
    headerClassName: 'super-app-theme--header',
    disableClickEventBubbling: true,
    renderCell: (params) => {
      const value = params.row.remarks ? params.row.remarks : ''
      const truncatedValue = value.length >= 27 ? value.substring(0, 27) + '...' : value
      return (
        <Tooltip title={value} placement="top-start">
          <div>{truncatedValue}</div>
        </Tooltip>
      )
    },
  }

  const loadBalancerIconRender = {
    field: '',
    headerName: 'Actions',
    disableColumnMenu: true,
    width: 101,
    headerClassName: 'super-app-theme--header',
    disableClickEventBubbling: true,
    renderCell: (params) => {
      return (
        <div>
          <Tooltip title="More details" placement="top-start">
            <Icon onClick={(event) => handleOpen(event, params.row)}>info_outlined</Icon>
          </Tooltip>
        </div>
      )
    },
  }
  loadBalancerColumns.push(loadBalancerRemarksRender)
  loadBalancerColumns.push(loadBalancerIconRender)

  caseDetailsColumns.push(loadBalancerRemarksRender)

  const dispatch = useDispatch()
  const reportingData = useSelector((state: RootState) => state.fetchReportingData)
  const loadBalanceLog = useSelector((state: RootState) => state.fetchLoadBalanceLog)
  const totalCount = loadBalanceLog.total_count

  useEffect(() => {
    dispatch(fetchLoadBalancerLog({ user_id: user, pageIndex: 1, pageSize: gridPageSize }))
  }, [user])

  const handleOpen = (event, rowData: any) => {
    setStatus(rowData.batchCasesData)
    setRunId(rowData.runId)
    setStatusOpen(true)
  }

  const handleClose = () => setStatusOpen(false)

  const handlePageChange = (page, details) => {
    dispatch(fetchLoadBalancerLog({ user_id: user, pageIndex: page + 1, pageSize: gridPageSize }))
  }

  return (
    <>
      <Dialog
        open={statusOpen}
        onClose={handleClose}
        fullWidth
        maxWidth={'md'}
        scroll={'paper'}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title" className={classes.dialogTitle}>
          More details for the job run {runId}
        </DialogTitle>
        <DialogContent dividers={true}>
          <DialogContentText
            id="scroll-dialog-description"
            // ref={descriptionElementRef}
            tabIndex={-1}
          >
            <DataGrid
              getRowId={(row) => row.caseNumber}
              disableColumnSelector
              autoHeight
              rows={status}
              columns={caseDetailsColumns}
              pagination
              pageSize={5}
              rowsPerPageOptions={[5]}
              disableExtendRowFullWidth
              sx={{
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: '#0d688d73',
                  fontWeight: '600',
                },
                '& .MuiDataGrid-columnHeader--moving': {
                  backgroundColor: 'transparent !important',
                },
              }}
              loading={reportingData?.fetchInProgress}
              onCellClick={(params, event) => {
                event.defaultMuiPrevented = true
                if (params.field === '') {
                  return
                }
              }}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            variant="outlined"
            endIcon={<ClearIcon />}
            className={`${classes.buttonMargin}`}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <DataGrid
        getRowId={(row) => row.runId}
        disableColumnSelector
        autoHeight
        rows={loadBalanceLog.data && loadBalanceLog.data.length > 0 ? loadBalanceLog.data : []}
        rowCount={totalCount}
        paginationMode="server"
        pageSize={gridPageSize}
        columns={loadBalancerColumns}
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#0d688d73',
            fontWeight: '600',
          },
          '& .MuiDataGrid-columnHeader--moving': {
            backgroundColor: 'transparent !important',
          },
        }}
        loading={loadBalanceLog?.fetchInProgress}
        onCellClick={(params, event) => {
          event.defaultMuiPrevented = true
          if (params.field === '') {
            return
          }
        }}
        onPageChange={(page, details) => {
          handlePageChange(page, details)
        }}
      />
    </>
  )
}
